import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Link } from "gatsby"

const StyledNavLink = styled(Link)`
  color: ${({theme}) => theme.color.grey};
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: bold;
  padding: 0 0.75rem;
  display: flex;
  align-items: center;
`

const UrlRegex = /^(?:[a-z]+:)?\/\//i

const NavLinkComp = ({href, children, ...rest}) => {
  const isExternal = UrlRegex.test(href)
  return isExternal ? (
    <StyledNavLink href={href} as={"a"} {...rest}>
      {children}
    </StyledNavLink>
    ) : (
    <StyledNavLink to={href} {...rest}>
      {children}
    </StyledNavLink>  
  )
}

NavLinkComp.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.any
}

export const NavLink = styled(NavLinkComp)``
